import React from "react";
import { Col, Row, Container } from "react-bootstrap";
import Back from '../Back/back';
import Theme from '../Theme/theme';
import "./footer.scss";

const Footer = () => {

    const getCurrentYear = () => {
        return new Date().getFullYear();
    };

    return (
        <footer className="footer">
            <Container fluid>
                <Container>
                    <Row>
                        <Col xs={12} className="text-center">
                            <p>&copy; {getCurrentYear()} Web Design of Boston. All rights reserved.</p>
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Back />
            <Theme />
        </footer>
    );
}

export default Footer;